/* eslint-disable react/no-unused-class-component-methods */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import moment from 'moment';
import Pagination from 'components/v2/PaginationV2';
import _ from 'underscore';
import Container from 'components/v2/container';
import queryObject from 'utils/query-object';
import AccountingActionCreators from 'actions/AccountingActionCreators';
import DateRangeFilter from 'components/time/DateRangeFilter';
import StatusFilter from 'components/ui/filters/status-filter';
import MultiSelectUser from 'components/site/multi-user-search';
import SessionStore from 'stores/SessionStore';
import { Trans, Translation, withTranslation } from 'react-i18next';
import {
  settleBulkStripePayout,
  generateAndEmailPayoutsReport,
} from 'utils/AccountingWebAPIUtils';
import { showToast } from 'stores/ToastStore';
import { findUsers } from 'utils/UserWebAPIUtils';
import formatMoney from 'utils/formatters/Money';
import { withLocaleContext } from 'providers/locale-settings-context';
import { getDefaultDateRangeFilter } from 'helpers/date-range';
import { sluggify } from 'utils/localization/utils';
import PayoutList from './payout-list';

function getTrueKeys(obj) {
  const keys = [];
  _.map(obj, (v, k) => {
    if (v) {
      keys.push(k);
    }
  });
  return keys;
}
const DEFAULT_DATE_RANGE_VALUES = {
  startValue: 1,
  startTimeUnit: 'month',
  startKey: {
    key: 'due_date',
  },
};
class PayoutModule extends Component {
  constructor(props) {
    super(props);
    const initial = {
      filters: {
        page: 1,
        page_size: 20,
        sort: {
          key: 'due_date',
          order: 'desc',
        },
        carrier: [],
        date_range: getDefaultDateRangeFilter(DEFAULT_DATE_RANGE_VALUES),
        type: {
          shorthaul: true,
          drayage: true,
        },
        status: {
          internal_review: true,
          approved_internally: true,
          payment_initialized: true,
          paid: true,
          void: true,
        },
        auto_pay: {
          enabled: true,
          disabled: true,
        },
        transfer_status: {
          initialized: true,
          created: true,
          paid: true,
          failed: true,
          reversed: true,
          canceled: true,
        },
        payment_method: {
          automated: true,
          manual: true,
        },
      },
      payouts: [],
      selectedPayouts: [],
      user: SessionStore.getUser(),
      carrierNames: [],
    };

    initial.filters = Object.assign(initial.filters, this.getUrlParams());

    this.state = initial;
  }

  componentDidMount() {
    if (this.state.filters.carrier.length) {
      this.fetchUsers(this.state.filters.carrier);
    }
    this.queryData(this.state.filters);
  }

  async fetchUsers(carrierIds) {
    try {
      const carriers = await findUsers({ _id: carrierIds });
      this.setState({ carrierNames: carriers.entity.items });
    } catch (e) {
      console.error(e);
    }
  }

  onSortChange() {
    return (sort) => {
      this.queryData(this.extendFilters({ sort }));
    };
  }

  onPaginationSelect(eventKey) {
    this.queryData(this.extendFilters({ page: eventKey }));
  }

  onDateRangeChange = ({ filterType, start, end }) => {
    this.setState(
      (prevState) => {
        const filters = { ...prevState.filters };
        if (filterType === 'clear') {
          filters.date_range = getDefaultDateRangeFilter(
            DEFAULT_DATE_RANGE_VALUES,
          );
        } else {
          filters.sort.key = filterType;
          filters.date_range = {
            key: filterType,
            start: moment(start).toISOString(),
            end: moment(end).toISOString(),
            page: 1,
          };
        }
        return { filters };
      },
      () => {
        this.queryData(this.state.filters);
      },
    );
  };

  getUrlParams() {
    const rawParams = queryObject(this.props.location);
    const params = {};
    const booleanFilters = [
      'type',
      'status',
      'transfer_status',
      'auto_pay',
      'payment_method',
    ];
    const arrayFilters = ['carrier'];
    Object.keys(rawParams).forEach((param) => {
      const key = decodeURIComponent(param);
      const val = decodeURIComponent(rawParams[param]);
      if (!/\[/.test(key)) {
        params[key] = val;
      } else {
        const keyElements = key.split('[');
        const topKey = keyElements[0];
        const subKey = keyElements[1].replace(']', '');
        if (arrayFilters.includes(topKey)) {
          if (!params[topKey]) {
            params[topKey] = [val];
          } else {
            params[topKey] = [...params[topKey], val];
          }
        } else {
          if (!params[topKey]) {
            params[topKey] = {};
          }
          // unfortunately qs doesn't convert strings to booleans, so we'll have to do that ourselves
          if (booleanFilters.indexOf(topKey) > -1) {
            params[topKey][subKey] = val === 'true';
          } else {
            params[topKey][subKey] = val;
          }
        }
      }
    });

    return params;
  }

  getDateRangeFilter() {
    const dateRange = this.state.filters.date_range;
    const defaultDateRangeFilter = getDefaultDateRangeFilter({
      options: 'object',
      ...DEFAULT_DATE_RANGE_VALUES,
    });
    return (
      <DateRangeFilter
        className="py-3 dropdown-filter-wrapper"
        onChange={this.onDateRangeChange}
        initialStart={defaultDateRangeFilter.start}
        initialEnd={defaultDateRangeFilter.end}
        startKey={dateRange.key || 'due_date'}
        endKey={dateRange.key === 'date_created' ? 'due_date' : 'date_created'}
      />
    );
  }

  queryData(filters) {
    AccountingActionCreators.getPayouts(filters).then((results) => {
      this.setState(
        (prevState) => {
          const payouts = results.entity.data;
          const { totalRevenue, count } = results.entity.meta;
          const totalPages = Math.ceil(count / prevState.filters.page_size);
          return {
            count,
            filters,
            payouts,
            totalPages,
            totalRevenue,
          };
        },
        () => this.updateUrl(this.state.filters),
      );
    });
  }

  updateUrl(filters) {
    const currentPath = this.props.location.pathname;
    this.props.history.push(`${currentPath}?${qs.stringify(filters)}`);
  }

  extendFilters(filter) {
    return Object.assign({}, this.state.filters, filter);
  }

  renderMultiCarrierSearch() {
    const { t } = this.props;
    return (
      <span style={{ display: 'inline-block' }}>
        <MultiSelectUser
          type="carriers"
          placeholder={t('SEARCH_FOR_CARRIER')}
          onSelect={(_value, item) => {
            this.handleCarrierFilterSelect(item, true);
          }}
          onRemove={(item) => {
            this.handleCarrierFilterSelect(item, false);
          }}
          selectedItems={this.state.carrierNames}
        />
      </span>
    );
  }

  handleCarrierFilterSelect(item, action) {
    if (action) {
      this.setState(
        (prevState) => {
          const carrier = [...prevState.filters.carrier, item._id];
          const filters = Object.assign({}, prevState.filters, { carrier });
          const carrierNames = [
            ...prevState.carrierNames,
            {
              _id: item._id,
              name: item.name,
            },
          ];
          return { carrierNames, filters };
        },
        () => {
          this.queryData(
            this.extendFilters({
              carrier: this.state.filters.carrier,
              page: 1,
            }),
          );
        },
      );
    } else {
      this.setState(
        (prevState) => {
          const filteredCarriers = prevState.filters.carrier.filter(
            (carrier) => carrier !== item._id,
          );
          const updatedCarrierNames = prevState.carrierNames.filter(
            (carrier) => carrier._id !== item._id,
          );
          return {
            ...prevState,
            carrierNames: [...updatedCarrierNames],
            filters: { ...prevState.filters, carrier: [...filteredCarriers] },
          };
        },
        () => {
          this.queryData(
            this.extendFilters({
              carrier: this.state.filters.carrier,
              page: 1,
            }),
          );
        },
      );
    }
  }

  resetFilter(filter) {
    return (actives) => {
      const statuses = Object.assign({}, this.state.filters[filter]);
      _.each(statuses, (v, status) => {
        statuses[status] = actives.indexOf(status) >= 0;
      });
      this.queryData(
        this.extendFilters({
          [filter]: Object.assign({}, this.state.filters[filter], statuses),
        }),
      );
    };
  }

  generateStatusFilter(title, filter, clearable, handler) {
    const statuses = this.state.filters[filter];
    return (
      <StatusFilter
        clear={clearable}
        className="dropdown-filter-wrapper"
        title={title}
        actives={getTrueKeys(statuses)}
        items={Object.keys(statuses)}
        onChange={handler}
      />
    );
  }

  onBulkSettlePayouts(payouts) {
    const selectedPayouts = this.state.payouts.filter(
      (payout) => payouts.indexOf(payout._id) >= 0,
    );
    this.setState((prevState) => ({
      ...prevState,
      selectedPayouts: selectedPayouts,
      showStripeConfirmationModal: true,
    }));
  }

  async onBulkSettlePayoutsConfirmation() {
    try {
      const selectedPayouts = [...this.state.selectedPayouts];
      const payoutIds = selectedPayouts.map((payout) => payout._id);
      this.setState({
        showStripeConfirmationModal: false,
      });
      const result = await settleBulkStripePayout(payoutIds);
      showToast(
        <Translation>
          {(t, { i18n }) => (
            <p>
              {t('BULK_STRIPE_PAYOUT_SUCCESS_MESSAGE', {
                success_count: result.entity.data.successes.length,
                failure_count: result.entity.data.failures.length,
              })}
            </p>
          )}
        </Translation>,
        <Translation>
          {(t, { i18n }) => (
            <p>
              {t('BULK_STRIPE_PAYOUT_SUCCESS_MESSAGE', {
                success_count: result.entity.data.successes.length,
                failure_count: result.entity.data.failures.length,
              })}
            </p>
          )}
        </Translation>,
        'success',
      );
      this.queryData(this.state.filters);
    } catch (e) {
      this.setState({
        showStripeConfirmationModal: false,
      });
      showToast(
        <Translation>
          {(t, { i18n }) => <p>{t('BULK_STRIPE_PAYOUT_FAILURE_MESSAGE')}</p>}
        </Translation>,
        <Translation>
          {(t, { i18n }) => <p>{t('BULK_STRIPE_PAYOUT_FAILURE_MESSAGE')}</p>}
        </Translation>,
        'error',
      );
    }
  }

  renderActiveFilters(filters) {
    const { t, formatDate } = this.props;
    const humanizeKeyList = (keys) =>
      keys.map((key) => `${t(sluggify(key))}`).join(', ');

    const getCarrierFilterResult = () => {
      if (filters.carrier.length) {
        return this.state.carrierNames.map((el) => el.name);
      }
      if (filters.auto_pay.enabled && filters.auto_pay.disabled) {
        return t('AUTO_MANUAL_PAY_CARRIERS');
      }
      if (filters.auto_pay.enabled) {
        return t('AUTO_PAY_CARRIERS');
      }
      if (filters.auto_pay.disabled) {
        return t('MANUAL_PAY_CARRIERS');
      }

      return t('NO_CARRIERS');
    };

    const msg = [t('PAYOUT', { count: 2 })];
    let key = 1;

    if (filters.date_range.key) {
      const text = t('DATE_KEY_START_TO_END', {
        date_key: t(sluggify(filters.date_range.key)),
        start: formatDate(filters.date_range.start),
        end: formatDate(filters.date_range.end),
      });
      msg.push(
        <span key={key}>
          {' '}
          {t('START_END_DATE_WITH_VALUE', { date: text })}&nbsp;
        </span>,
      );
      key += 1;
    }

    const trueShipmentTypeKeys = getTrueKeys(filters.type);
    if (trueShipmentTypeKeys.length > 0) {
      msg.push(
        <span key={key}>
          {t('SHIPMENT_TYPES_WITH_VALUE', {
            shipmentType: humanizeKeyList(trueShipmentTypeKeys),
          })}
        </span>,
      );
      key += 1;
    }

    const trueStatusKeys = getTrueKeys(filters.status);
    if (trueStatusKeys.length > 0) {
      msg.push(
        <span key={key}>
          ,{' '}
          {t('STATUSES_WITH_VALUE', {
            statuses: humanizeKeyList(trueStatusKeys),
          })}
        </span>,
      );
      key += 1;
    }

    const trueTransferStatusKeys = getTrueKeys(filters.transfer_status);
    if (trueTransferStatusKeys.length > 0) {
      msg.push(
        <span key={key}>
          ,{' '}
          {t('TRANSFER_STATUSES_WITH_VALUE', {
            transferStatuses: humanizeKeyList(trueTransferStatusKeys),
          })}
        </span>,
      );
      key += 1;
    }

    const truePaymentMethodStatusKeys = getTrueKeys(filters.payment_method);
    if (truePaymentMethodStatusKeys.length > 0) {
      msg.push(
        <span key={key}>
          ,{' '}
          {t('PAYMENT_METHOD_STATUSES_WITH_VALUE', {
            paymentStatuses: humanizeKeyList(truePaymentMethodStatusKeys),
          })}
        </span>,
      );
      key += 1;
    }

    msg.push(
      <span key={key}>
        &nbsp;
        {t('FOR_FILTER_RESULT_WITH_VALUE', {
          filterResult: getCarrierFilterResult(),
        })}
      </span>,
    );

    return (
      <div className="flex flex-wrap md:-mx-4">
        <div className="w-full md:px-4 md:w-1/2">
          <p>{msg}</p>
        </div>
        <div className="w-full md:px-4 md:w-1/2">
          <p className="lead" style={{ textAlign: 'right' }}>
            <Trans
              i18nKey="PAYOUTS_TOTALLING"
              values={{
                totalCount: this.state.count,
                totalRevenue: formatMoney(
                  this.state.totalRevenue,
                  DEFAULT_CURRENCY,
                ),
              }}
              components={[<strong />, <span />]}
            />
          </p>
        </div>
      </div>
    );
  }

  renderHeader(filters) {
    const { t } = this.props;
    const dateRangeFilter = this.getDateRangeFilter();
    const shipmentTypeFilters = this.generateStatusFilter(
      t('SHIPMENT_TYPE'),
      'type',
      true,
      this.resetFilter('type'),
    );
    const statusFilters = this.generateStatusFilter(
      t('PAYOUT_STATUS'),
      'status',
      true,
      this.resetFilter('status'),
    );
    const autoPayStatusFilter = this.generateStatusFilter(
      t('STRIPE_STATUS'),
      'auto_pay',
      false,
      this.resetFilter('auto_pay'),
    );
    const transferStatusFilters = this.generateStatusFilter(
      t('BANK_TRANSFER_STATUS'),
      'transfer_status',
      true,
      this.resetFilter('transfer_status'),
    );
    const paymentMethodFilters = this.generateStatusFilter(
      t('PAYMENT_METHOD'),
      'payment_method',
      true,
      this.resetFilter('payment_method'),
    );
    const requireTransferStatusFilters =
      filters.auto_pay.enabled &&
      (filters.status.paid || filters.status.pending);
    const conditionalTransferStatusFilters = requireTransferStatusFilters
      ? transferStatusFilters
      : '';

    return (
      <div className="flex flex-wrap md:-mx-4">
        <div className="mb-4 md:px-4">{dateRangeFilter}</div>
        <div className="mb-4 md:px-4">{this.renderMultiCarrierSearch()}</div>
        <div className="mb-4 md:px-4">{shipmentTypeFilters}</div>
        <div className="mb-4 md:px-4">{statusFilters}</div>
        <div className="mb-4 md:px-4">{autoPayStatusFilter}</div>
        <div className="mb-4 md:px-4">{conditionalTransferStatusFilters}</div>
        <div className="mb-4 md:px-4">{paymentMethodFilters}</div>
      </div>
    );
  }

  handleSendPayoutsReportToEmail = (recipients) => {
    try {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            recipients,
          },
        }),
        async () => {
          await generateAndEmailPayoutsReport(this.state.filters);
        },
      );
    } catch (e) {
      // Handled in APIUtils
    }
  };

  render() {
    return (
      <Container className="py-8">
        {this.renderHeader(this.state.filters)}
        {this.renderActiveFilters(this.state.filters)}
        <div className="mt-4">
          <PayoutList
            payouts={this.state.payouts}
            sort={this.state.filters.sort}
            onSortChange={this.onSortChange()}
            handleSendPayoutsReportToEmail={this.handleSendPayoutsReportToEmail}
          />
          <Pagination
            first
            last
            pages={this.state.totalPages}
            page={parseInt(this.state.filters.page, 10)}
            onPageClick={(eventKey) => this.onPaginationSelect(eventKey)}
            perPage={this.props.perPage}
            total={this.state.count}
          />
        </div>
      </Container>
    );
  }
}

PayoutModule.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withTranslation()(withLocaleContext(PayoutModule));
